import { ThreeCardGameOverScreen } from '@/screens/three-card-poker/ThreeCardGameOverScreen'

export default function () {
  return <ThreeCardGameOverScreen />
}
